import { KeycloakIonicService } from "./keycloak-ionic.service";

export function initializer(keycloakIonicService: KeycloakIonicService) {
    return (): Promise<any> => {
        return keycloakIonicService.initAuth();
    }
}